"use strict";

var _defineProperty = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/defineProperty.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReactiveFilterSharedProps = void 0;

var react_1 = __importDefault(require("react"));

var useReactiveReactProp_1 = require("./useReactiveReactProp");
/**
 * For use with all @appbaseio/reactivesearch filter components
 */


var useReactiveFilterSharedProps = function useReactiveFilterSharedProps(filter) {
  var reactiveReactProp = (0, useReactiveReactProp_1.useReactiveReactProp)(filter.handle, filter);
  var nestedField = react_1.default.useMemo(function () {
    var nestedFields = ["variants"];
    var topField = filter.field.split(".")[0];
    if (nestedFields.includes(topField)) return topField;
    return undefined;
  }, [filter]); // define a custom query for when settingsHideUnavailable is enabled and the target field is inside variants
  // customQuery defines how this filter affects *other* components like the results component

  var customQuery = react_1.default.useMemo(function () {
    if (!filter.settingsHideUnavailable || !filter.field.startsWith("variants.")) return undefined;
    return function (value) {
      if (!value) return {}; // reactivesearch sometimes returns string, sometimes string[]

      var valueArray = "string" === typeof value ? [value] : value;
      if (0 === valueArray.length) return {};
      return {
        query: {
          nested: {
            path: "variants",
            query: {
              bool: {
                must: [{
                  match: {
                    "variants.available": "true"
                  }
                }, {
                  terms: _defineProperty({}, filter.field, valueArray)
                }]
              }
            }
          }
        }
      };
    };
  }, [filter]); // define a default query for when settingsHideUnavailable is enabled and the target field is inside variants
  // defaultQuery defines how this filter affects itself i.e. the options displayed

  var defaultQuery = react_1.default.useMemo(function () {
    if (!filter.field.startsWith("variants.")) {
      return undefined;
    } // override the aggregation query to filter the results by the variants.available attribute


    return function () {
      return {
        aggs: {
          reactivesearch_nested: {
            nested: {
              path: "variants"
            },
            aggs: {
              reactify_nested_outer: {
                filter: {
                  bool: {
                    minimum_should_match: 1,
                    should: [{
                      match: {
                        "variants.available": "true"
                      }
                    }, {
                      match: {
                        "variants.available": filter.settingsHideUnavailable ? "true" : "false"
                      }
                    }]
                  }
                },
                aggs: _defineProperty({}, filter.field, {
                  terms: {
                    field: filter.field,
                    size: 100,
                    order: {
                      _count: "desc"
                    }
                  },
                  aggs: {
                    parent_docs: {
                      reverse_nested: {}
                    }
                  }
                })
              }
            }
          }
        }
      };
    };
  }, [filter]);
  var reactiveFilterSharedProps = react_1.default.useMemo(function () {
    return {
      nestedField: nestedField,
      customQuery: customQuery,
      defaultQuery: defaultQuery,
      URLParams: true,
      componentId: filter.handle,
      dataField: filter.field,
      filterLabel: filter.name,
      react: reactiveReactProp
    };
  }, [filter, reactiveReactProp]);
  return reactiveFilterSharedProps;
};

exports.useReactiveFilterSharedProps = useReactiveFilterSharedProps;